import { axiosInstance } from 'config';
import { EmployeeInformationResponse } from './employee.model';

class EmployeeAPI {
  getEmployeeInformation(userName) {
    return axiosInstance
      .get<EmployeeInformationResponse>(
        `/servicios_fijos/v1/employees/${userName}`
      )
      .then(({ data }) => data);
  }
}

export default new EmployeeAPI();
